import { FC } from 'react';
import ClickTrackingIcon from '../../primitive/Icons/ClickTrackingIcon';
import EventTrackingIcon from '../../primitive/Icons/EventTrackingIcon';
import PageVisitIcon from '../../primitive/Icons/PageVisitIcon';
import TransactionIcon from '../../primitive/Icons/TransactionIcon';

type Props = {
  goalType: string;
};

const GoalTypeIcon: FC<Props> = ({ goalType }) => {
  if (goalType === 'event') {
    return <EventTrackingIcon />;
  } else if (goalType === 'page_visit') {
    return <PageVisitIcon />;
  } else if (goalType === 'transaction') {
    return <TransactionIcon />;
  } else if (goalType === 'click') {
    return <ClickTrackingIcon />;
  } else {
    return null;
  }
};

export default GoalTypeIcon;
